
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Guest } from "@/hooks/use-event-form";
import { GuestPreviewList } from "@/components/event-details/add-guests/components/GuestPreviewList";
import { DuplicateNameDialog } from "@/components/event-details/add-guests/components/DuplicateNameDialog";
import { UserPlus } from "lucide-react";

interface GuestAccordionProps {
  guestList: Guest[];
  onGuestListChange: (guests: Guest[]) => void;
}

export const GuestAccordion = ({ guestList, onGuestListChange }: GuestAccordionProps) => {
  const [firstName, setFirstName] = useState("");
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);

  const resetForm = () => {
    setFirstName("");
  };

  const handleAddGuest = (e: React.FormEvent) => {
    e.preventDefault();

    if (checkDuplicateName(firstName)) {
      setIsDuplicateModalOpen(true);
      return;
    }

    const newGuest = {
      firstName,
      lastName: "",
    };

    onGuestListChange([...guestList, newGuest]);
    resetForm();
  };

  const checkDuplicateName = (name: string) => {
    return guestList.some(
      guest => guest.firstName.toLowerCase() === name.toLowerCase()
    );
  };

  const handleRemoveGuest = (index: number) => {
    const updatedGuests = [...guestList];
    updatedGuests.splice(index, 1);
    onGuestListChange(updatedGuests);
  };

  return (
    <div className="space-y-6">
      <form onSubmit={handleAddGuest} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="guestName">Guest Name</Label>
          <div className="flex gap-2">
            <Input
              id="guestName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="i.e. John Doe"
              className="flex-1"
            />
            <Button 
              type="submit"
              variant="secondary"
              disabled={!firstName.trim()}
            >
              <UserPlus className="w-4 h-4 mr-2" />
              Add
            </Button>
          </div>
        </div>
      </form>

      <GuestPreviewList 
        guests={guestList.map(g => ({ ...g, phoneNumber: "" }))} 
        onRemoveGuest={handleRemoveGuest}
      />

      <DuplicateNameDialog
        isOpen={isDuplicateModalOpen}
        onClose={() => setIsDuplicateModalOpen(false)}
      />
    </div>
  );
};
